import React from 'react'
import { TranslationFunction } from '../../../../common/types'
import { FooterWrapper, ListingsContainer, LoadMoreButton } from './styles'
import SkeletonRow from './skeleton-row'

export interface VirtuosoContext {
    isGridView: boolean
    loading: boolean
    isInitializing: boolean
    hasNextPage: boolean
    loadMore: () => void
    t: TranslationFunction
    error: Error | null
    hasItems: boolean
}

export const VirtuosoList = React.forwardRef<HTMLDivElement, any>(({ children, context, ...props }, ref) => (
    <ListingsContainer ref={ref} {...props} isGridView={(context as VirtuosoContext).isGridView}>
        {children}
    </ListingsContainer>
))
VirtuosoList.displayName = 'VirtuosoList'

export const VirtuosoFooter = ({ context }: { context: VirtuosoContext }) => {
    const showSkeletons = !context.isInitializing && context.hasItems && context.loading
    const showLoadMore = !context.isInitializing && context.hasItems && !context.loading && context.hasNextPage

    return (
        <FooterWrapper>
            {showSkeletons && (
                <>
                    <SkeletonRow isGridView={context.isGridView} />
                    <SkeletonRow isGridView={context.isGridView} />
                    <SkeletonRow isGridView={context.isGridView} />
                    <SkeletonRow isGridView={context.isGridView} />
                    <SkeletonRow isGridView={context.isGridView} />
                </>
            )}
            {showLoadMore && <LoadMoreButton onClick={context.loadMore}>{context.t('showMore')}</LoadMoreButton>}
        </FooterWrapper>
    )
}
